
import React, { Fragment } from "react";
 import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  getReadCount
} from "../../config/url.json";
import { CONFIG } from "../../config/data";
import axios from "axios";

function SideBar(props) {

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("token");
    props.logout();
    props.history.push("/");
  };
 // let message_count = props.appdata?props.appdata[0].message_count : "";
 const [click, setClick] = React.useState(false);

  const handleClick = () => setClick(!click);
  return (
    <div className={click ? "sidebar-toggleon toggle" : " toggle"} >

    <button  onClick={()=>handleClick()} >
    <i className="fa fa-bars" aria-hidden="true"></i>
    </button>
      
    <div className="vertical-menu displaymobilenone scrollbox">
      <div data-simplebar="">
        {/* <!--- Sidemenu --> */}
        <div id="sidebar-menu">
          {/*   <!-- Left Menu Start -->*/}
          <ul className="metismenu list-unstyled" id="side-menu">
          
           
            <li className="sidmnl">
              <a
                href="/dashboard"
                className=" waves-effect"
                aria-expanded="false"
              >
                <i className="fa-solid fa-house"></i>
                <span> Dashboard</span>
             </a>
              </li>
              
              {(props.user.user_type === 'doctor'||props.user.user_type === 'business_user'||props.user.user_type === 'Doctor') ?
              (
                <Fragment>
                  <li className="sidmnl">
                <a
                  href="/consult"
                  className=" waves-effect"
                  aria-expanded="false"
                >
                  <i className="fa-solid fa-user-doctor"></i>
                  <span> Consult</span>
                </a>
              </li>
           {/* {(props.user.speciality_name!=='Physiotherapy' && props.user.speciality_name!=='Mental Wellness' )?
                (<li className="sidmnl">
                <a
                  href="/consult"
                  className=" waves-effect"
                  aria-expanded="false"
                >
                  <i className="fa-solid fa-user-doctor"></i>
                  <span> Consult</span>
                </a>
              </li>):''}
              {(props.user.speciality_name=='Physiotherapy')?
              (<li className="sidmnl">
                <a
                  href="/consult"
                  className=" waves-effect"
                  aria-expanded="false"
                >
                  <i className="fa-solid fa-user-doctor"></i>
                  <span> Consult Physiotherapist</span>
                </a>
              </li>):''} */}
              {/* {(props.user.speciality_name=='Mental Wellness')?
              (<li className="sidmnl">
                <a
                  href="/consult"
                  className=" waves-effect"
                  aria-expanded="false"
                >
                  <i className="fa-solid fa-user-doctor"></i>
                  <span> Consult Mental Wellness</span>
                </a>
              </li>):''} */}
             
              <li>
              <a
               /*  href="#" */
                className="has-arrow waves-effect"
                aria-expanded="false"
              >
               <i className="fas fa-calendar-week"></i>
                <span> In Patient</span>
              </a>
              <ul className="ulcls mm-collapse">
                
                <a href="/InpatientAssesmentDoctor">
                  <li>
                
                  <i class="fa-solid fa-person-walking-arrow-loop-left"></i>
                  Inpatient Assesment Doctor
                  </li>
                </a>
              </ul>
            </li>
            
              <li className="sidmnl">
                <a
                  href="/doctorshift_planner"
                  className=" waves-effect"
                  aria-expanded="false"
                >
                 <i className="fas fa-sticky-note"></i>
                  <span> Shift Planner</span>
                </a>
              </li>
             {/*  <li className="sidmnl">
                <a
                  href="/canvas"
                  className=" waves-effect"
                  aria-expanded="false"
                >
                 <i className="fas fa-sticky-note"></i>
                  <span> Canvas</span>
                </a>
              </li> */}
             {/*  <li className="sidmnl">
                <a
                  href="/PrescriptionTemplate"
                  className=" waves-effect"
                  aria-expanded="false"
                >
                 <i className="fas fa-sticky-note"></i>
                  <span> PrescriptionTemplate</span>
                </a>
              </li> */}
              </Fragment>
              ):(props.user.user_type === 'business'||props.user.user_type === 'hospital')?(
                <Fragment>
                <li className="sidmnl">
                  <a
                    href="/queuelist"
                    className=" waves-effect"
                    aria-expanded="false"
                  >
                    {/* <i className="fas fa-key"></i> */}
                    <i class="fa-solid fa-clipboard-list"></i>
                    <span> Token List</span>
                  </a>
                </li>
                <li className="sidmnl">
                  <a
                    href="/appointmentlist"
                    className=" waves-effect"
                    aria-expanded="false"
                  >
                   <i className="fas fa-calendar-check"></i>
                    <span> Appointment List</span>
                  </a>
                </li>
                <li>
              <a
              
                className="has-arrow waves-effect"
                aria-expanded="false"
              >
                <i className="fas fa-key"></i>
                <span> Token</span>
              </a>
              <ul className="ulcls mm-collapse">
                <a href="/patient-checkin">
                  <li>
                  {/* <i className="fas fa-location-arrow"></i> */}
                  <i class="fa-solid fa-person-walking-arrow-right"></i>
                    Patient Check-In
                  </li>
                </a>
                <a href="/queue_assignment">
                  <li>
                  {/* <i className="fas fa-location-arrow"></i> */}
                  <i class="fa-solid fa-person-walking-arrow-loop-left"></i>
                   Patient Check-Out
                  </li>
                </a>
               
              </ul>
            </li>
            <li>
              <a
               /*  href="#" */
                className="has-arrow waves-effect"
                aria-expanded="false"
              >
               <i className="fas fa-calendar-week"></i>
                <span> Appointment</span>
              </a>
              <ul className="ulcls mm-collapse">
                <a href="/appointment-checkin">
                  <li>
                  {/* <i className="fas fa-location-arrow"></i> */}
                  <i class="fa-solid fa-person-walking-arrow-right"></i>
                    Patient Check-In
                  </li>
                </a>
                <a href="/ApptCheckout">
                  <li>
                  {/* <i className="fas fa-location-arrow"></i> */}
                  <i class="fa-solid fa-person-walking-arrow-loop-left"></i>
                   Patient Check-Out
                  </li>
                </a>
               
              </ul>
            </li>

            <li>
              <a
               /*  href="#" */
                className="has-arrow waves-effect"
                aria-expanded="false"
              >
               <i className="fas fa-calendar-week"></i>
                <span> In Patient Module</span>
              </a>
              <ul className="ulcls mm-collapse">
                <a href="/InPatientCheckin">
                  <li>
                
                  <i class="fa-solid fa-person-walking-arrow-right"></i>
                   In Patient Check-In
                  </li>
                </a>
                <a href="/InpFacilityList">
                  <li>
                
                  <i class="fa-solid fa-person-walking-arrow-loop-left"></i>
                  In Patient Facility List
                  </li>
                </a>
                <a href="/InpRoomTransfer">
                  <li>
                
                  <i class="fa-solid fa-person-walking-arrow-loop-left"></i>
                  In Patient Room Transfer
                  </li>
                </a>
                <a href="/InpatientList">
                  <li>
                
                  <i class="fa-solid fa-person-walking-arrow-loop-left"></i>
                  In Patient List
                  </li>
                </a>
                {/* <a href="/inpatient/:id">
                  <li>
                
                  <i class="fa-solid fa-person-walking-arrow-loop-left"></i>
                  In Patient Consultation
                  </li>
                </a> */}
                <a href="/InPatientBilling">
                  <li>
                
                  <i class="fa-solid fa-person-walking-arrow-loop-left"></i>
                  In Patient Billing
                  </li>
                </a>
                <a href="/AmbulanceManagement">
                  <li>
                
                  <i class="fa-solid fa-person-walking-arrow-loop-left"></i>
                  Ambulance Management
                  </li>
                </a>
                <a href="/InpatientAssesmentDoctor">
                  <li>
                
                  <i class="fa-solid fa-person-walking-arrow-loop-left"></i>
                  Inpatient Assesment Doctor
                  </li>
                </a>
               
              </ul>
            </li>
                {/* <li className="sidmnl">
                <a
                  href="/patient-checkin"
                  className="waves-effect"
                  aria-expanded="false"
                >
                  <i className="">
                  <img alt="" src={require("../../assets/images/icon5.png")} />
                  </i>
                  <span> Patient Check-In</span>
                </a>
              </li>
              <li className="sidmnl">
                <a
                  href="/appointment-checkin"
                  className="waves-effect"
                  aria-expanded="false"
                >
                  <i className="">
                  <img alt="" src={require("../../assets/images/icon5.png")} />
                  </i>
                  <span> Appointment Check-In</span>
                </a>
              </li>
              <li className="sidmnl">
                <a
                  href="/queue_assignment"
                  className=" waves-effect"
                  aria-expanded="false"
                >
                  <i className="">
                  <img alt="" src={require("../../assets/images/icon14.png")} />
                  </i>
                  <span>Patient Check-Out</span>
                </a>
              </li>
              <li className="sidmnl">
                <a
                  href="/ApptCheckout"
                  className=" waves-effect"
                  aria-expanded="false"
                >
                  <i className="">
                  <img alt="" src={require("../../assets/images/icon14.png")} />
                  </i>
                  <span>Appt Patient Check-Out</span>
                </a>
              </li> */}
              <li className="sidmnl">
                <a
                  href="/shift_planner"
                  className=" waves-effect"
                  aria-expanded="false"
                >
                 {/* <i className="fas fa-sticky-note"></i> */}
                 {/* <i class="fa-solid fa-code-compare"></i>  */}
                 <i class="fa-solid fa-people-arrows"></i>
                  <span> Shift Planner</span>
                </a>
              </li>

              </Fragment>
              ):""}
              
              {(props.user.user_type === 'pharmacy') ? (
                <Fragment>
    {/*             <li className="sidmnl">
                  <a
                    href="/prescriptionlist"
                    className=" waves-effect"
                    aria-expanded="false"
                  >
                   
                    <i class="fa-solid fa-clipboard-list"></i>
                    <span> Prescription List</span>
                  </a>
                </li>
                <li className="sidmnl">
                  <a
                    href="/pharmacydrugslist"
                    className=" waves-effect"
                    aria-expanded="false"
                  >
                   <i className="fas fa-calendar-check"></i>
                    <span>Drug List</span>
                  </a>
                </li>
                <li className="sidmnl">
                  <a
                    href="/pharmacydruglist"
                    className=" waves-effect"
                    aria-expanded="false"
                  >
                   <i className="fas fa-calendar-check"></i>
                    <span>Item List</span>
                  </a>
                </li>
                <li className="sidmnl">
                  <a
                    href="/manufacturerlist"
                    className=" waves-effect"
                    aria-expanded="false"
                  >
                   <i className="fas fa-calendar-check"></i>
                    <span>Manufacturer List</span>
                  </a>
                </li>
                <li className="sidmnl">
                  <a
                    href="/vendorlist"
                    className=" waves-effect"
                    aria-expanded="false"
                  >
                   <i className="fas fa-calendar-check"></i>
                    <span>Vendor List</span>
                  </a>
                </li> */}
                <li>
              <a
              
                className="has-arrow waves-effect"
                aria-expanded="false"
              >
                <i className="fas fa-key"></i>
                <span>Masters</span>
              </a>
              <ul className="ulcls mm-collapse">
              <a href="/prescriptionlist">
                  <li>
                 
                  <i className="fas fa-calendar-check"></i>
                  Prescription List
                  </li>
                </a>
              <a href="/pharmacydrugslist">
                  <li>
                 
                  <i className="fas fa-calendar-check"></i>
                  Drug List
                  </li>
                </a>
                <a href="/pharmacydruglist">
                  <li>
                 
                  <i className="fas fa-calendar-check"></i>
                  Item List
                  </li>
                </a>
                <a href="/manufacturerlist">
                  <li>
                 
                  <i className="fas fa-calendar-check"></i>
                  Manufacturer List
                  </li>
                </a>
                <a href="/vendorlist">
                  <li>
                 
                  <i className="fas fa-calendar-check"></i>
                  Vendor List
                  </li>
                </a>
                <a href="/customerlist">
                  <li>
                 
                  <i className="fas fa-calendar-check"></i>
                  Customer List
                  </li>
                </a>
              </ul>
            </li>
            <li>
              <a
              
                className="has-arrow waves-effect"
                aria-expanded="false"
              >
                <i className="fas fa-key"></i>
                <span>Purchase</span>
              </a>
              <ul className="ulcls mm-collapse">
              <a href="/purchaseentryvoucher">
                  <li>
                 
                  <i className="fas fa-calendar-check"></i>
                  Purchase Entry Voucher
                  </li>
                </a>
              <a href="/purchaseregister">
                  <li>
                 
                  <i className="fas fa-calendar-check"></i>
                  Purchase Register
                  </li>
                </a>
                <a href="/purchasereport">
                  <li>
                 
                  <i className="fas fa-calendar-check"></i>
                  Purchase Report
                  </li>
                </a>
                 <a href="/purchasereturnvoucher">
                  <li>
                 
                  <i className="fas fa-calendar-check"></i>
                 Purchase Return Voucher
                  </li>
                </a>
                <a href="/expirybreakagednvoucher">
                  <li>
                 
                  <i className="fas fa-calendar-check"></i>
                 Expiry/ Brk Return Voucher
                  </li>
                </a>
                <a href="/debitnoteregister">
                  <li>
                 
                  <i className="fas fa-calendar-check"></i>
                  Debit Note Register
                  </li>
                </a>
                <a href="/openingstockupload">
                  <li>
                 
                  <i className="fas fa-calendar-check"></i>
                  Opening Stock Upload
                  </li>
                </a>           
              </ul>
            </li>
            <li>
              <a
              
                className="has-arrow waves-effect"
                aria-expanded="false"
              >
                <i className="fas fa-key"></i>
                <span>Sales</span>
              </a>
              <ul className="ulcls mm-collapse">
              <a href="/saleentryvoucher">
                  <li>
                 
                  <i className="fas fa-calendar-check"></i>
                  Sale Entry Voucher
                  </li>
                </a>
              <a href="/saleregister">
                  <li>
                 
                  <i className="fas fa-calendar-check"></i>
                  Sales Register
                  </li>
                </a>
                <a href="/salereturnvoucher">
                  <li>
                 
                  <i className="fas fa-calendar-check"></i>
                  Sale Return Voucher
                  </li>
                </a>
                <a href="/creditnoteregister">
                  <li>
                 
                  <i className="fas fa-calendar-check"></i>
                  Credit Note Register
                  </li>
                </a>
              </ul>
            </li>

            <li>
              <a
              
                className="has-arrow waves-effect"
                aria-expanded="false"
              >
                <i className="fas fa-key"></i>
                <span>Stock</span>
              </a>
              <ul className="ulcls mm-collapse">
              <a href="/stockandsalesreport">
                  <li>
                 
                  <i className="fas fa-calendar-check"></i>
                  Stock and Sales Report
                  </li>
                </a>
              <a href="/batchwisestockreport">
                  <li>
                 
                  <i className="fas fa-calendar-check"></i>
                  Batch Wise Stock Report
                  </li>
                </a>
              
              </ul>
            </li>
            {/* <li>
              <a
              
                className="has-arrow waves-effect"
                aria-expanded="false"
              >
                <i className="fas fa-key"></i>
                <span>Debit Note</span>
              </a>
              <ul className="ulcls mm-collapse">
             
             
              
              </ul>
            </li> */}
{/* 
                <li className="sidmnl">
                  <a
                    href="/purchaseentryvoucher"
                    className=" waves-effect"
                    aria-expanded="false"
                  >
                   <i className="fas fa-calendar-check"></i>
                    <span>Purchase Entry Voucher</span>
                  </a>
                </li>
                <li className="sidmnl">
                  <a
                    href="/purchaseregister"
                    className=" waves-effect"
                    aria-expanded="false"
                  >
                   <i className="fas fa-calendar-check"></i>
                    <span>Purchase Register</span>
                  </a>
                </li>
                <li className="sidmnl">
                  <a
                    href="/purchasereport"
                    className=" waves-effect"
                    aria-expanded="false"
                  >
                   <i className="fas fa-calendar-check"></i>
                    <span>Purchase Report</span>
                  </a>
                </li>
               */}
                          

              </Fragment>
              ):""}


              {/* <li className="sidmnl">
              <ul
                className="ulcls mm-collapse"
                aria-expanded="false"
                style={{ height: "8px" }}
              >
                {(props.user.user_type === 'doctor'||props.user.user_type === 'business_user') ? 
                (<a href="/consult">
                  <li>
                    <img
                      alt=""
                      src={require("../../assets/images/icon5.png")}
                    />
                    Consult{" "}
                  </li>
                </a>):""}
                <a href="/patient-checkin">
                  <li>
                    <img
                      alt=""
                      src={require("../../assets/images/icon5.png")}
                    />
                    Patient Check-in{" "}
                  </li>
                </a>
                <a href="/appointments">
                  <li>
                    <img src={require("../../assets/images/icon14.png")} />
                    Appointments
                  </li>
                </a>
                <a href="/queue_assignment">
                  <li>
                    <img src={require("../../assets/images/icon14.png")} />
                    Queue Assignment
                  </li>
                </a>
                <a href="/queuelist">
                  <li>
                    <img src={require("../../assets/images/icon13.png")} />
                    Queue List
                  </li>
                </a>
                <a href={() => false}>
                  <li>
                    <img src={require("../../assets/images/icon15.png")} />
                    Prescription
                  </li>
                </a>
                <a href={() => false}>
                  <li>
                    <img src={require("../../assets/images/icon25.png")} />
                    QR code
                  </li>
                </a>
              </ul>
              </li> */}
{(props.user.user_type === 'doctor'||props.user.user_type === 'business_user'||props.user.user_type === 'Doctor'||props.user.user_type === 'pharmacy') ? "":(
  <Fragment>
  <li className="sidmnl">
              <a
               /*  href="#" */
                className="has-arrow waves-effect"
                aria-expanded="false"
              >
               <i className="fas fa-users"></i>
                <span> Profile</span>
              </a>

              <ul className="ulcls mm-collapse">
              <a href="/profile">
                  <li>
                  <i className="fas fa-user"></i>
                    My Account
                  </li>
                </a> 
                <a href="/businessuser-profile">
                  <li>
                  <i className="fas fa-users"></i>
                    Employee profile{" "}
                  </li>
                </a>              
                <a href="/client-profile">
                  <li>
                  <i className="fas fa-user"></i>
                    Patient profile
                  </li>
                </a>
              </ul>
            </li>

            <li>
              <a
               /*  href="#" */
                className="has-arrow waves-effect"
                aria-expanded="false"
              >
               <i className="fas fa-user-cog"></i>
                <span> Admin reports</span>
              </a>
              <ul className="ulcls mm-collapse">
                <a href="/clients">
                  <li>
                  <i className="fas fa-clipboard-list"></i>
                    Patients List
                  </li>
                </a>
                <a href="/businessuser-list">
                  <li>
                  <i className="fas fa-clipboard-list"></i>
                    Employee List
                  </li>
                </a>
                <a href="/facilitylist">
                  <li>
                  <i className="fas fa-laptop-house"></i>
                    Facility List
                  </li>
                </a>
                <a href="/VisitList">
                  <li>
                  <i className="fas fa-bahai"></i>
                    Token Visit List
                  </li>
                </a>
                <a href="/VisitApptList">
                  <li>
                  <i className="fas fa-eye"></i>
                    Appt Visit List
                  </li>
                </a>
               
              </ul>
            </li>

            <li>
              <a
              /*   href="#" */
                className="has-arrow waves-effect"
                aria-expanded="false"
              >
                <i className="fas fa-clinic-medical"></i>
                <span> Clinical management</span>
              </a>
              <ul className="ulcls mm-collapse" style={{ borderbottom: 0 }}>
                <a href="/drugs">
                  <li>
                  <i className="fas fa-pills"></i>
                    Drug List
                  </li>
                </a>
                <a href="/medicinesupplies">
                  <li>
                  <i className="fas fa-hand-holding-medical"></i>
                    Medicine Supplies List
                  </li>
                </a>
                {/* <a href={() => false}>
                  <li>
                    <img
                      alt=""
                      src={require("../../assets/images/icon10.png")}
                    />
                    Doctor List
                  </li>
                </a> */}
                                           
                 <a href="/pharmacyList">
                 <li>
                 <i className="fas fa-hospital-alt"></i>
                Pharmacy List
                </li>
              </a>
             
                 { /* < a href="/pharmacyProfile">
                  <li>
                    <img
                      alt=""
                      src={require("../../assets/images/icon22.png")}
                    />
                    Pharmacy List
                  
                   
                  </li>
                </a>
*/ }            
              
                <a href="/labList">
                  <li>
                  <i className="fas fa-vials"></i>
                    Lab List
                  </li>
                </a>
                <a href="/disease">
                  <li>
                  <i className="fas fa-disease"></i>
                    Disease List
                  </li>
                </a>

                <a href="/symptom">
                  <li>
                  <i className="fas fa-thermometer-full"></i>
                    Symptoms List
                  </li>
                </a>
              </ul>
            </li>
                        
            <li className="sidmnl">
              <a
                href="/inbox"
                className="waves-effect"
                aria-expanded="false"
              >
               <i className="fas fa-bell"></i>
                <span>Notifications</span><span className="badge badge-light notificationicon"></span>
                {props.message_count > 0 ? (<span className="pulse bg-danger"></span>):""}
              </a>
            </li>
            </Fragment> 
            )}
   

            <li className="sidmnl">
              <a
                href="/referrals"
                className="waves-effect"
                aria-expanded="false"
              >
               <i className="fas fa-sync-alt"></i>
                <span>Referrals</span>
              </a>
            </li>
            {(props.user.user_type === 'doctor'||props.user.user_type === 'business_user'|| props.user.user_type === 'Doctor') ? (
              <li className="sidmnl">
              <a
                href={"/profile"}
                className="waves-effect"
                aria-expanded="false"
              >
               <i className="fas fa-user-alt"></i>
                <span>My Account</span>
              </a>
            </li>
            ):""}
            
            {/* <li>
              <a href={() => false} className="waves-effect" aria-expanded="false">
                <i className="">
                  <img src={require("../../assets/images/icon17.png")} />
                </i>
                <span>Finance</span>
              </a>
            </li> */}
            <li>
              <a href="/supportweb" className="waves-effect" aria-expanded="false">
              <i className="fas fa-headset"></i>
                <span>Support</span>
              </a>
            </li>
           {(props.user.user_type === 'hospital')?(
            <li>
              <a href="/showsubscription" className="waves-effect" aria-expanded="false">
              <i className="fas fa-file-invoice-dollar"></i>
                <span>Show Subscription</span>
              </a>
            </li>):""}

            <li>
              <a href="/qr_code" className="waves-effect" aria-expanded="false">
              <i className="fas fa-qrcode"></i>
                <span>QR code</span>
              </a>
            </li>
            <li>
              <a href="/qrscanner" className="waves-effect" aria-expanded="false">
              <i className="fas fa-qrcode"></i>
                <span>QR Reader</span>
              </a>
            </li>

            <li>
              <a href="/viewoffers" className="waves-effect" aria-expanded="false">
              <i className="fas fa-percent"></i>
                <span>Offers</span>
              </a>
            </li>

            <li>
              <a href="/faqweb" className="waves-effect" aria-expanded="false">
              <i className="fas fa-comment-dots"></i>
                <span>FAQ</span>
              </a>
            </li>

            <li className="sidmnl sidmnlss">
              <a
                href="#"
                className="waves-effect"
                aria-expanded="false"
                onClick={handleLogout}
              >
                <i className="fas fa-sign-out-alt"></i>
                <span>Sign out</span>
              </a>
            </li>
            
          </ul>
        </div>
        {/*<!-- Sidebar -->*/}
      </div>
    </div>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    loggedIn: state.AuthReducer.loggedIn,
    appdata: state.AppData,
    user: state.AuthReducer.user,
    message_count: state.AuthReducer.message_count,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch({ type: "SET_LOGOUT" }),
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SideBar)
);
